const fromQueryPlacePredictionsToPlacePredictions = (data) => {
  if (!data) {
    return null;
  }
  return data.map(({ id, locality, sublocality }) => ({
    id,
    locality,
    sublocality: sublocality ?? void 0
  }));
};
export {
  fromQueryPlacePredictionsToPlacePredictions as default
};
//# sourceMappingURL=fromQueryPlacePredictionsToPlacePredictions.js.map
